// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal_2OJVT","list":"list_ZzRYs","textRight":"textRight_2P3AO","contentBox":"contentBox_3WZyP","btnChange":"btnChange_1sF-L"};